export default __webpack_public_path__ + "static/media/card_unusual.d7de1936.svg";